// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GrowthProfilesTable_GrowthProfileFragment = { __typename?: 'GrowthProfile', id: string, displayName: string, exemptionGrowthRate: Percent, isDefault: boolean, assetGrowthReturn?: Percent | null, growthType: Types.GrowthProfileGrowthType, user: { __typename?: 'User', id: string, displayName: string }, estateWaterfalls: (
    { __typename?: 'EstateWaterfallConnection' }
    & GrowthProfilesTable_EstateWaterfallConnectionFragment
  ) };

export type GrowthProfilesTable_EstateWaterfallConnectionFragment = { __typename?: 'EstateWaterfallConnection', totalCount: number, edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: { __typename?: 'EstateWaterfall', id: string } | null } | null> | null };

export type GrowthProfilesTableQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.GrowthProfileWhereInput>;
}>;


export type GrowthProfilesTableQuery = { __typename?: 'Query', growthProfiles: { __typename?: 'GrowthProfileConnection', totalCount: number, edges?: Array<{ __typename?: 'GrowthProfileEdge', node?: (
        { __typename?: 'GrowthProfile' }
        & GrowthProfilesTable_GrowthProfileFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GrowthProfilesTable: 'GrowthProfilesTable' as const
  },
  Fragment: {
    GrowthProfilesTable_GrowthProfile: 'GrowthProfilesTable_GrowthProfile' as const,
    GrowthProfilesTable_EstateWaterfallConnection: 'GrowthProfilesTable_EstateWaterfallConnection' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GrowthProfilesTable_EstateWaterfallConnectionFragmentDoc = gql`
    fragment GrowthProfilesTable_EstateWaterfallConnection on EstateWaterfallConnection {
  totalCount
  edges {
    node {
      id
    }
  }
}
    `;
export const GrowthProfilesTable_GrowthProfileFragmentDoc = gql`
    fragment GrowthProfilesTable_GrowthProfile on GrowthProfile {
  id
  displayName
  exemptionGrowthRate
  user {
    id
    displayName
  }
  isDefault
  assetGrowthReturn
  growthType
  estateWaterfalls {
    ...GrowthProfilesTable_EstateWaterfallConnection
  }
}
    ${GrowthProfilesTable_EstateWaterfallConnectionFragmentDoc}`;
export const GrowthProfilesTableDocument = gql`
    query GrowthProfilesTable($where: GrowthProfileWhereInput) {
  growthProfiles(where: $where) {
    totalCount
    edges {
      node {
        ...GrowthProfilesTable_GrowthProfile
      }
    }
  }
}
    ${GrowthProfilesTable_GrowthProfileFragmentDoc}`;

/**
 * __useGrowthProfilesTableQuery__
 *
 * To run a query within a React component, call `useGrowthProfilesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthProfilesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthProfilesTableQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGrowthProfilesTableQuery(baseOptions?: Apollo.QueryHookOptions<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>(GrowthProfilesTableDocument, withFetchPolicyContext(options));
      }
export function useGrowthProfilesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>(GrowthProfilesTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGrowthProfilesTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>(GrowthProfilesTableDocument, withFetchPolicyContext(options));
        }
export type GrowthProfilesTableQueryHookResult = ReturnType<typeof useGrowthProfilesTableQuery>;
export type GrowthProfilesTableLazyQueryHookResult = ReturnType<typeof useGrowthProfilesTableLazyQuery>;
export type GrowthProfilesTableSuspenseQueryHookResult = ReturnType<typeof useGrowthProfilesTableSuspenseQuery>;
export type GrowthProfilesTableQueryResult = Apollo.QueryResult<GrowthProfilesTableQuery, GrowthProfilesTableQueryVariables>;